import { withProfiling } from '../self-measurements';
export var roundEpsilon = withProfiling(function roundEpsilon(num) {
  var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var factor = Math.pow(10, places);
  return Math.round((num + Number.EPSILON) * factor) / factor;
});